'use client';

import React, { useEffect, useState } from 'react';
import { api } from 'src/services/api';
import RefundRequestsUI, { RefundRequestItem } from './ui';
import { toast } from 'react-toastify';

export default function RefundRequestsScreen() {
  const [items, setItems] = useState<RefundRequestItem[]>([]);
  const [loading, setLoading] = useState(false);

  async function load() {
    setLoading(true);
    try {
      const response = await api.get('/order/repayments-solicitations');
      const data = Array.isArray(response) ? response : (response?.data ?? []);
      const mapped = mapApiItems(data);
      setItems(mapped);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }

  function mapApiItems(data: any[]): RefundRequestItem[] {
    return data.map((d) => {
      const order = d.order ?? {};
      const user = d.repaymentUser ?? {};
      const firstSeller = Array.isArray(d.sellers) ? d.sellers[0] : null;
      const orderSeller = firstSeller?.orderSeller ?? {};
      return {
        id: String(d.id),
        orderNumber: String(order.code ?? ''),
        userName: String(order.client ?? user.name ?? ''),
        sellerName: String(orderSeller.sellerName ?? 'Seller'),
        sellerId: String(orderSeller.seller ?? ''),
        orderId: String(order?.id ?? ''),
        orderValue: Number(order.totalValue ?? orderSeller.totalValue ?? 0),
        orderDate: String(order.orderDate ?? ''),
        createdAt: String(d.repaymentSolicitationDate ?? ''),
        motive: String(d.repaymentMotive ?? ''),
        status: String(
          d.repaymentStatus ?? 'PENDENTE'
        ).toUpperCase() as RefundRequestItem['status'],
        sellerStatus: String(
          firstSeller?.repaymentStatus ?? 'PENDENTE'
        ).toUpperCase() as RefundRequestItem['sellerStatus'],
        images: (d.images ?? []).map((i: any) => ({ imageUrl: i.imageUrl })),
      };
    });
  }

  async function approve(id: string, sellerId: string) {
    try {
      await api.post('/order/confirm-repayment-order', {
        id,
        seller: sellerId,
      });
      setItems((prev) =>
        prev.map((i) =>
          i.id === id && i.sellerId === sellerId
            ? { ...i, sellerStatus: 'APROVADA' }
            : i
        )
      );
      toast.success('Solicitação aprovada com sucesso!');
    } catch {
      toast.error('Erro ao aprovar solicitação.');
    }
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <RefundRequestsUI items={items} loading={loading} onApprove={approve} />
  );
}
